import { c as _c } from "react/compiler-runtime";
import { cx, type VariantProps } from 'class-variance-authority';
import { render, MARK_LINK, NODE_HEADING, NODE_LI, NODE_OL, NODE_PARAGRAPH, NODE_UL } from 'storyblok-rich-text-react-renderer';
import Link from 'next/link';
import { textColorVariant, marginBottomVariant, alignmentVariant } from '~/utils/variants';
import { cn } from '~/utils';
import type { SB_RichtextProps } from '../components/types.generated';
import type { JSX } from 'react';
export function renderRichText(text: SB_RichtextProps) {
  return render(text, {
    markResolvers: {
      [MARK_LINK]: (children, {
        href,
        target
      }) => <Link className={cx('font-bold underline')} href={href as string} target={target}>
                    {children}
                </Link>
    },
    nodeResolvers: {
      [NODE_HEADING]: (children, {
        level
      }) => {
        const Heading = `h${level}` as const satisfies keyof JSX.IntrinsicElements;
        return <Heading>{children}</Heading>;
      },
      [NODE_PARAGRAPH]: children => <p className="mb-3">{children}</p>,
      [NODE_UL]: children => <ul className="mb-3 list-inside list-disc">{children}</ul>,
      [NODE_OL]: children => <ol className="mb-3 list-inside list-decimal">{children}</ol>,
      [NODE_LI]: children => <li className="mb-1 *:inline">{children}</li>
    }
  });
}
const RichText: React.FC<{
  text: SB_RichtextProps;
  className?: string;
} & VariantProps<typeof textColorVariant> & VariantProps<typeof marginBottomVariant> & VariantProps<typeof alignmentVariant>> = t0 => {
  const $ = _c(10);
  const {
    className,
    text,
    textColor: t1,
    spacing,
    alignment: t2
  } = t0;
  const textColor = t1 === undefined ? "primary" : t1;
  const alignment = t2 === undefined ? "left" : t2;
  let t3;
  if ($[0] !== alignment || $[1] !== className || $[2] !== spacing || $[3] !== textColor) {
    t3 = cn("storyblok-content", textColorVariant({
      textColor
    }), marginBottomVariant({
      spacing
    }), alignmentVariant({
      alignment
    }), className);
    $[0] = alignment;
    $[1] = className;
    $[2] = spacing;
    $[3] = textColor;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== text) {
    t4 = renderRichText(text);
    $[5] = text;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default RichText;